module.exports = __webpack_public_path__ + "img/star.6d210b48.svg";